<atn-ds-table [config]="agentAssignmentsTableConfig" />

<atn-admin-agent-assignment-modal [hasPageContext]="true" />

@let markedUserForUnassignment =
  agentAssignmentFeature.selectors.markedUserForUnassignment.asSignal();
@if (markedUserForUnassignment) {
  @let mutationError =
    agentAssignmentFeature.selectors.mutationErrorMessage.asSignal();
  <atn-ds-confirmation-overlay
    title="Unassign User"
    [description]="
      'Unassigning ' +
      markedUserForUnassignment.name +
      ' from the selected agent can\'t be undone. Are you sure you want to continue?'
    "
    [error]="mutationError"
    (cancel)="cancelUnassignmentClickHandler()"
    (confirm)="confirmUnassignmentClickHandler()"
    confirmButtonText="Confirm"
  />
}
